import { WithHiddenItems } from '../amr-pipeline/models/WithHiddenItems';
import { City } from '../location/City';
import { Country } from '../location/Country';
import { State } from '../location/State';
import { CloManagerBase } from './CloManagerBase';
import { CloManagerInvestmentTeamMember } from './CloManagerInvestmentTeamMember';
import { CloManagerStats } from './CloManagerStats';

export interface CloManagerDetailed extends CloManagerBase {
    stats: CloManagerStats;
    city: City;
    state: State;
    country: Country;
    investmentTeam: WithHiddenItems<CloManagerInvestmentTeamMember>;
    status: CloManagerStatus;
}

export enum CloManagerStatus {
    Active = 'Active',
    Inactive = 'Inactive',
}
